// react
import { ReactNode, useContext } from 'react';

// router
import { Link as RouterLink } from 'react-router-dom';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Entity, Project } from '../../../@types';

// context
import { ContextProject } from '../../pages/Project/Project.context';

// mui
import { Box, Link, LinkProps, SxProps, Typography } from '@mui/material';

// theme
import { theme } from '../../../theme';

// props
export interface LinkEntityProps extends LinkProps {
	children?: ReactNode;
	entity?: Entity | null;
	hasEllipsis?: boolean;
	project?: Project;
	[x: string]: unknown;
}

export const LinkEntity = ({
	children,
	entity,
	hasEllipsis,
	project,
	...props
}: LinkEntityProps) => {
	// hooks
	const { t } = useTranslation();

	// context
	const { project: projectContext } = useContext(ContextProject);

	// vars
	let link = <Typography>{t('na')}</Typography>;

	if (entity) {
		const content = children || entity.name;
		const projectId = project ? project.idWbg : projectContext?.idWbg;

		let url = `/project/${projectId}/entity/${entity.id}`;

		let sx: SxProps = {
			wordBreak: 'break-word',
		};

		if (entity.type === 'BENEFICIARY') {
			url = `/project/${projectId}/beneficiary/${entity.id}`;
		}

		if (entity.type === 'SUPPLIER') {
			url = `/project/${projectId}/supplier/${entity.id}`;
		}

		if (!entity.id) {
			return <Typography fontWeight={600}>{entity.name}</Typography>;
		}

		if (hasEllipsis) {
			sx = {
				...sx,
				[theme.breakpoints.up('md')]: {
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
				},
			};
		}

		link = (
			<Link component={RouterLink} fontWeight={600} sx={sx} to={url} underline="hover" {...props}>
				{content}
			</Link>
		);

		if (hasEllipsis) {
			link = <Box sx={{ display: 'flex', flexDirection: 'column' }}>{link}</Box>;
		}
	}

	return link;
};
